import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useSessionStore } from '../../stores/sessionStore';
import Route from '../route';

export default function logout(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void
{
    useSessionStore().sessions.clear();
    useSessionStore().$reset();
    return next({ name: Route.Splash.name });
}
